import React from 'react'
import PropTypes from 'prop-types'
import parse, { domToReact } from 'html-react-parser'
import { StyledContainer } from './CKEditorContent.styled'
import { Link } from 'gatsby'

const options = {
  replace: ({ attribs, children }) => {
    if (attribs?.href) {
      const isInternalLink = attribs?.href.charAt(0) === '/'
      return isInternalLink ? (
        <Link to={attribs?.href}>{domToReact(children, options)}</Link>
      ) : (
        <a href={attribs?.href} target="_blank" rel="noreferrer noopener">
          {domToReact(children, options)}
        </a>
      )
    }
  },
}

const CKEditorContent = ({ className, html }) => {
  return (
    <StyledContainer className={`content ${className}`}>
      {parse(html, options)}
    </StyledContainer>
  )
}

CKEditorContent.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string,
}

export default CKEditorContent
